import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorRoute: InvariantJiraRoute = {
	name: 'legacy-gin',
	path: '/issues/:issueKey(.*)?',
};
